import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, StudyPlanTargets, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"
import { setSPV2RedirectUrl } from "../studyPlanV2/actions"
import { BASE_STUDY_PLAN_V2_ADMIN_MANAGE_PATH } from "../studyPlanV2/constants"

export const editPublishedPlanTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  exit: assign<Context>({ publishedStudyPlan: null }),
  invoke: {
    id: "buildPopulatedStudyPlan",
    src: "buildPopulatedStudyPlan",
    onDone: {
      target: "edit_plan",
      actions: assign((_ctx, evt) => ({
        studyPlan: evt.data.plan,
        // Collapse all sections when user enters edit state.
        expanded: []
      }))
    },
    onError: [
      {
        target: `${BASE_STUDY_PLAN_V2_ADMIN_MANAGE_PATH}`,
        actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => ({
          ...setSPV2RedirectUrl(
            ctx,
            evt,
            null,
            StudyPlanTargets.ManageStudyPlans
          ),
          snackbar: {
            message: getServiceErrorMessage("newPlan", {
              errorReason: evt.data.message,
              messageData: ["create a new plan"]
            }),
            withUndo: false,
            error: true
          }
        })),
        cond: ctx => ctx.isStudyPlanV2Enabled
      },
      {
        target: "#StudyPlan.study_plans_overview.idle",
        cond: (ctx, _evt) =>
          ctx.selfRefScope.scope === "DISTRICT" ||
          ctx.selfRefScope.scope === "SCHOOL",
        actions: assign<Context, DoneInvokeEvent<any>>({
          snackbar: (_ctx, evt) => ({
            message: getServiceErrorMessage("newPlan", {
              errorReason: evt.data.message,
              messageData: ["create a new plan"]
            }),
            withUndo: false,
            error: true
          })
        })
      },
      {
        target: "#StudyPlan.teacher_view.idle",
        cond: (ctx, _evt) => ctx.selfRefScope.scope === "TEACHER",
        actions: assign<Context, DoneInvokeEvent<any>>({
          snackbar: (_ctx, evt) => ({
            message: getServiceErrorMessage("newPlan", {
              errorReason: evt.data.message,
              messageData: ["create a new plan"]
            }),
            withUndo: false,
            error: true
          })
        })
      }
    ]
  }
}
